import React from "react";
import styled from "@emotion/styled";

const defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
};

export const RawTypography = styled.p(
  ({
    theme,
    variant,
    align,
    wrap,
    gutterBottom,
    paragraph,
    display,
    color
  }) => ({
    /* Styles applied to the root element. */
    margin: 0,
    ...theme.typography[variant],
    ...{ textAlign: align },
    ...(wrap && {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }),
    ...(gutterBottom && {
      marginBottom: "0.35em"
    }),
    ...(paragraph && {
      marginBottom: 16
    }),
    ...(display && {
      display: display
    }),
    ...((color === "primary" || color === "secondary" || color === "error") && {
      color: theme.palette[color].main
    }),
    ...((color === "textPrimary" || color === "textSecondary") && {
      color: theme.palette.text[color]
    }),
    ...(color === "inherit" && {
      color: "inherit"
    })
  })
);

console.log("!!", RawTypography);
const Typography = (props) => {
  const { component, paragraph, variant, variantMapping } = props;

  const finalComponent =
    component ||
    (paragraph
      ? "p"
      : variantMapping[variant] || defaultVariantMapping[variant]) ||
    "span";

  const Component = RawTypography.withComponent(finalComponent);

  return <Component {...props} />;
};

Typography.defaultProps = {
  align: "inherit",
  color: "initial",
  display: "initial",
  gutterBottom: false,
  noWrap: false,
  paragraph: false,
  variant: "body1",
  variantMapping: defaultVariantMapping
};

export default Typography;
